// extracted by mini-css-extract-plugin
module.exports = {"fold":"Folder_fold__2cptN","title":"Folder_title__1V2xS","green":"Folder_green__1fF5o","big":"Folder_big__2Mbuj","body":"Folder_body__AqP7b"};